import React from 'react';
import { ParagraphGroup } from '../paragraph-group';
import style from "./style.module.css";

export interface ISolutionHeaderProps {
    title: string;
    description?: string;
}

export function SolutionHeader(props: ISolutionHeaderProps) {
    return (
        <section className={style.solutionHeader}>
            <h2 className={style.title}>{props.title}</h2>
            {
                props.description ?
                    <ParagraphGroup
                        body={
                            [
                                props.description
                            ]
                        }
                        groupStyle={style.description}
                    />
                    : null
            }
        </section>
    )
}